import { Breadcrumbs } from '../models/breadcrumbs.model';

export const breadcrumbsFor = {
  HOME: 'HOME',
  MEET_CCTV: 'MEET_CCTV',
  ARCHIVE: 'ACERVO',
  MULTIMEDIA: 'MULTEMIDIA',
  HOW_TO_ARRIVE: 'COMO_CHEGAR',
  CONTACT_US: 'FALE_CONOSCO',
  NEWS: 'NOTICIAS',
  TIME_TABLE: 'TIME_TABLE',
  EXPOSITIONS: 'EXPOSITIONS',
  DOWNLOAD_MAP: "DOWNLOAD_MAP",
};

export const breadcrumbs: Breadcrumbs = {
  [breadcrumbsFor.HOME]: {
    breadcrumb: {
      show: false
    }
  },
  [breadcrumbsFor.MEET_CCTV]: {
    breadcrumb: {
      show: true,
      current: 'STRUCTURE.MEET_THE_CCTV'
    }
  },
  [breadcrumbsFor.ARCHIVE]: {
    breadcrumb: {
      show: true,
      current: 'STRUCTURE.ARCHIVE'
    }
  },
  [breadcrumbsFor.MULTIMEDIA]: {
    breadcrumb: {
      show: true,
      current: 'STRUCTURE.MULTIMEDIA'
    }
  },
  // [breadcrumbsFor.NEWS]: {
  //   breadcrumb: {
  //     show: true,
  //     current: 'STRUCTURE.NEWS'
  //   }
  // },
  [breadcrumbsFor.HOW_TO_ARRIVE]: {
    breadcrumb: {
      show: true,
      current: 'STRUCTURE.HOW_TO_ARRIVE'
    }
  },
  [breadcrumbsFor.TIME_TABLE]: {
    breadcrumb: {
      show: true,
      current: 'STRUCTURE.TIME_TABLE'
    }
  },
  [breadcrumbsFor.CONTACT_US]: {
    breadcrumb: {
      show: true,
      current: 'STRUCTURE.CONTACT_US'
    }
  },
  [breadcrumbsFor.EXPOSITIONS]: {
    breadcrumb: {
      show: true,
      current: "STRUCTURE.EXPOSITIONS"
    }
  },
  [breadcrumbsFor.DOWNLOAD_MAP]: {
    breadcrumb: {
      show: true,
      current: "BAIXAR MAPA"
    }
  }
};

